'use client'
import imgWorker from './icons/user.png'
import imgOrg from './icons/buildings.png'
import RadioGroup from '@/src/components/common/RadioGroup'
import bgimage from './bgimage.png'
import Img from '@/src/components/common/Img/Img'
import styles from '../../OnboardingForm.module.scss'
import { classNames } from '@/src/helpers/component'
import { useState } from 'react'
import { readStoredData } from '@/src/components/common/OnboardingForm/OnboardingForm.client'

export default function EmploymentMoreDetailsForm() {
  const [onboardingData] = useState(readStoredData())

  const options = [
    { icon: imgWorker.src, value: 'I am an independent worker' },
    { icon: imgOrg.src, value: 'I am an organisation' },
  ]

  const name = 'more_details__employment__entity'

  return (
    <>
      <div>
        <h3 className={styles.heading}>
          Which of these options best describe your work situation?
        </h3>
        <RadioGroup
          required
          options={options}
          name={name}
          value={(onboardingData.data?.[name] || '') as string}
          className={classNames(styles.iconOptions)}
        />
      </div>
      <Img src={bgimage.src} />
    </>
  )
}
